var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos2Default(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,21V65H75V21ZM73,63H37V23H73Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.72,37.41a4.89,4.89,0,0,0-1.11-2.78,3.94,3.94,0,0,0-2.81-1.19s-3.91-.28-9.8-.28-9.8.28-9.8.28a3.94,3.94,0,0,0-2.81,1.19,4.89,4.89,0,0,0-1.11,2.78A36.89,36.89,0,0,0,41,41.94v2.12a36.89,36.89,0,0,0,.28,4.53,4.94,4.94,0,0,0,1.11,2.78,4.73,4.73,0,0,0,3.09,1.19s2.24.22,9.52.28c5.89,0,9.8-.29,9.8-.29a4.05,4.05,0,0,0,2.81-1.18,4.94,4.94,0,0,0,1.11-2.78A39.35,39.35,0,0,0,69,44.06V41.94A39.35,39.35,0,0,0,68.72,37.41ZM52.11,46.63V38.77l7.56,3.95Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos2Default);
export default __webpack_public_path__ + "static/media/videos2-default.8ba53c9b2b4dbff8f4140bdc959e905c.svg";
export { ForwardRef as ReactComponent };